import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./ConfirmPasswordRenewal.css";
import {
	validatePasswordChange,
} from "../redux/users/usersActions";
import { withRouter } from "react-router-dom";
import { Card, CardActions, CardContent, CardHeader, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = {
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
		marginTop: "10px",
		paddingLeft: "15px",
	},
};

class ConfirmPasswordRenewal extends Component {

	componentDidMount() {
		let { token } = this.props.match.params

		if (!token) {
			console.error("Token invalide");
			return;
		}

		this.props.validatePasswordChange(token);
	}

	render() {
		const { classes } = this.props;

		return (
			<div className="container">
				<Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin">
					<CardHeader title={"Changement de mot de passe"} />
					<CardContent>
						<Typography>
							{this.props.changePasswordMessage}
						</Typography>
					</CardContent>
					<CardActions className={classes.cardActions} disableSpacing>
						<a href="/" className="btn btn-primary btn-lg">
							<span className="glyphicon glyphicon-home"></span>
                            Accueil
                         </a>
					</CardActions>
				</Card>
			</div >
		);
	}
}

// export default withRouter(Login)
const mapStateToProps = (state) => {
	return {
		changePasswordMessage: state.changePassword.changePasswordMessage
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		validatePasswordChange: (token) => dispatch(validatePasswordChange(token)),
	};
};
export default compose(withRouter, withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps))(ConfirmPasswordRenewal);
